const ON_CHANGE_DEBOUNCE_TIMER = 300;
const RESIZE_DEBOUNCE_TIMER = 250;
const SLIDE_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  gridContentFetch: 'grid-content-fetch',
  gridContentUpdate: 'grid-content-update',
  filter: 'filter',
  quickviewLoad: 'quickview-load',
  addToWishlist: 'add-to-wishlist',
  removeFromWishlist: 'remove-from-wishlist',
  modalShow: 'modal-show',
  modalHide: 'modal-hide',
  zoomChange: 'zoom-change',
};

const VALUE_PATTERNS = {
  boolean: /^(true|false)$/,
  number: /^\d+(\.\d+)?$/,
}